class MainNav {
  constructor() {
    this.$container = $('body');
    this.$mainNav = this.$container.find('.nav-primary')
    this.$mainHeader = this.$container.find('.main-header')
    this.scopeRole = {
      menuItem: 'a.menu-item',
      subMenu: '.sub-menu',
      dropdownTrigger: '.dropdown-trigger',
    }
    if (this.$mainNav.length) {
      this.initialize()
    }
  }

  initialize() {
    this.$mainNav.find(this.scopeRole.menuItem)
      .on('mouseenter', () => {
        if(!this.$mainHeader.hasClass('scrolled')) {
          this.$mainHeader.addClass('bg-blue-4')
        }
        if(this.$container.hasClass('single') || this.$container.hasClass('archive')) {
          $('svg.logo-white').addClass('inline-block')
          $('svg.logo-blue').addClass('hidden')
        }
      })
    // On Masque le sous menu quand on sort du menu
    this.$mainNav.find(this.scopeRole.subMenu)
      .on('mouseleave', () => {
        this.$mainHeader.removeClass('bg-blue-4')
        if(this.$container.hasClass('single') || this.$container.hasClass('archive')) {
          $('svg.logo-white').removeClass('inline-block')
          $('svg.logo-blue').removeClass('hidden')
        }
      })
    this.$mainNav.find(this.scopeRole.dropdownTrigger)
      .on('click', (evt) => {
        const $el = $(evt.currentTarget)
        $el.preventDefault()
      })
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./scripts/navigation/MainNav.js